import RightMenu from './RightMenu';

export default RightMenu;
